import { render } from "./SocialAndCommercialVitalityView.vue?vue&type=template&id=207ebee1&scoped=true"
import script from "./SocialAndCommercialVitalityView.vue?vue&type=script&lang=js"
export * from "./SocialAndCommercialVitalityView.vue?vue&type=script&lang=js"

import "./SocialAndCommercialVitalityView.vue?vue&type=style&index=0&id=207ebee1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207ebee1"]])

export default __exports__